<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
      v-show="activity"
    >
    <h1 v-if="!activityImageUrl" style="color: white;">JODA</h1>
    </parallax>
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="md-layout" v-if="false">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="liff-activity">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="JODA icon"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <!-- <div class="name">
                  <h3 class="title">Installation</h3>
                  <h6>安裝 JODA</h6>
                  <p class="description text-center">
                    請選擇您使用的行動平台
                  </p>
                </div> -->
                <div class="name">
                  <h3 class="title" v-if="activityId === undefined">沒有可以操作的內容</h3>
                </div>
              </div>
              
            </div>
          </div>

          <div class="margin_bottom_10 margin_top_20" v-if="activity">
            <div class="md-layout">
              <div
                class="md-layout-item md-size-80 md-xsmall-size-100 mx-auto" style="padding-top: 20px;"
              >
                <h4 v-if="activity.group" style="margin: 0; line-height: 2rem; color: #0271C9;"><b>{{ activity.group.name }}</b></h4>
                <h2 style="margin: 0 0 33px 0; line-height: 1.6rem;">{{ activity.name }}</h2>

                <pre style="font-size:16px;">{{ activity.notes }}</pre>

                <br/>
              
                <div class="md-layout" style="display: flex; align-items: center;">
                  <div class="md-layout-item" style="padding-end: 0px;">
                    <p style="margin: 0; line-height: 100%; font-size: 16px;"><b>{{ activityStartTime.toLocaleDateString([], { hour12: false, month: "2-digit", day: "2-digit", weekday: "short" }) }}</b></p>
                    <p style="margin: 0; line-height: 100%; font-size: 34px;"><b>{{ activityStartTime.toLocaleTimeString([], { hour12: false, hour: '2-digit', minute:'2-digit'}) }}</b></p>
                  </div>
                  <div class="md-layout-item" style="padding: 0;">
                    <hr/>
                  </div>
                  <div class="md-layout-item" style="padding-start: 0px;">
                    <p style="margin: 0; line-height: 100%; font-size: 16px; text-align: right;"><b>{{ activityEndTime.toLocaleDateString([], { hour12: false, month: "2-digit", day: "2-digit", weekday: "short" }) }}</b></p>
                    <p style="margin: 0; line-height: 100%; font-size: 34px; text-align: right;"><b>{{ activityEndTime.toLocaleTimeString([], { hour12: false, hour: '2-digit', minute:'2-digit'}) }}</b></p>
                  </div>
                </div>
              
                <br/>

                <div v-if="activity.minParticipant != 1 || activity.maxParticipant != 0" class="md-layout" style="display: flex; align-items: baseline;">
                  <div v-if="activity.minParticipant == activity.maxParticipant" class="md-layout-item" style="text-align: right;">
                    <p style="display: inline; margin-end: 2px;">人數</p><p style="display: inline; font-size: 34px;"><b>{{ activity.minParticipant }}</b></p>
                  </div>
                  <div v-else-if="activity.minParticipant == 1" class="md-layout-item" style="text-align: right;">
                    <p style="display: inline; margin-end: 2px;">最多人數</p><p style="display: inline; font-size: 34px;"><b>{{ activity.maxParticipant }}</b></p>
                  </div>
                  <div v-else-if="activity.maxParticipant == 0" class="md-layout-item" style="text-align: right;">
                    <p style="display: inline; margin-end: 2px;">最少人數</p><p style="display: inline; font-size: 34px;"><b>{{ activity.minParticipant }}</b></p>
                  </div>
                  <div v-else class="md-layout-item" style="text-align: right;">
                    <p style="display: inline; margin-end: 2px;">人數</p><p style="display: inline; font-size: 34px;"><b>{{ activity.minParticipant }} ~ {{ activity.maxParticipant }}</b></p>
                  </div>
                </div>

                <br/>

                <div class="md-layout" style="display: flex; align-items: baseline;">
                  <div class="md-layout-item" style="padding-end: 0px;">
                    <h5>{{ activity.location }}</h5>
                  </div>
                  <div class="md-layout-item" style="padding-start: 0px; text-align: right;">
                    <p v-if="activity.fee" style="display: inline; margin-end: 2px;">TWD</p><p style="display: inline; font-size: 34px;"><b>{{ activity.fee }}</b></p>
                  </div>
                </div>

                <br/>

                <p style="margin: 0">主揪</p>
                <div v-if="activity.host" class="md-layout" style="display: flex; align-items: center;">
                  <div class="md-layout-item md-size-20" style="padding: 0px; margin-start: 15px;">
                    <img
                      :src="activity.host.imageUrl || img"
                      :alt="activity.host.name || 'host'"
                      class="img-raised rounded-circle img-fluid"
                      style="width: 17vw; margin: 4px;"
                    />
                  </div>
                  <div class="md-layout-item" style="padding: 0px;">
                    <p style="margin: 0px; font-size:20px;">{{ activity.host.name }}</p>
                  </div>
                </div>
                

                <br/>

                <p v-if="activity.participants.length" style="margin: 0">咖</p>
                <div>
                  <div class="md-layout" v-for="(participant, index) in activity.participants" :key="participant.id || index" style="display: flex; align-items: center;">
                    <div v-if="participant.user" class="md-layout-item md-size-20" style="padding: 0px; margin-start: 15px;">
                      <img
                        :src="participant.user.imageUrl || img"
                        :alt="participant.user.name || 'participant'"
                        class="img-raised rounded-circle img-fluid"
                        style="height: 17vw; width: 17vw; margin: 0px; object-fit: cover;"
                      />
                    </div>
                    <div v-if="participant.user" class="md-layout-item" style="padding: 0px; position: relative;">
                      <p style="margin: 0px; margin-bottom: 2px; font-size:20px; max-lines: 1; color: #3C1E0B;">{{participant.user.name}}</p>
                      <p style="margin: 0px; font-size:20px; max-lines: 1; color: #7B5016;">{{particiantNoteOf(index, participant)}}</p>
                    </div>
                    <div class="md-layout-item md-size-25" style="position: relative; padding: 0">
                      <h3 style="margin: 0px 8px 0px 0px; text-align: right; font-size:54px; font-style: italic; position: relative;" :style="particiantIndexStyle(index, participant)">
                        <b>#{{particiantIndexNumberOf(index)}}</b>
                      </h3>
                      <div style="position: absolute; top: 50%; left: 0; width: 100%; align-items: center; margin-top: 2px;">
                        <p style="margin: 0px; text-align: right; margin-right: 8px; font-size:20px; max-lines: 1; white-space: nowrap; text-overflow: ellipsis; color: #0271C9;">{{ voucherNameOf(participant) }}</p>
                      </div>
                      <div v-if="!simulation && appUserId && participant.user && (participant.user.id === appUserId)" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center;">
                        <md-button class="md-danger md-just-icon md-round" style="margin: auto;" @click="leave(participant)">
                          <md-icon>cancel</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </div>

                <br/>

                <p v-if="comments.length" style="margin: 0">留言</p>
                <div>
                  <div v-for="(comment, index) in comments" :key="index" style="margin-top: 4px; margin-bottom: 14px; margin-start: 0px; margin-end: 0px;">
                    <div class="md-layout-item" style="display: flex; padding: 0px;">
                      <img
                        :src=comment.commenter.imageUrl
                        :alt=comment.commenter.name
                        class="img-raised rounded-circle img-fluid"
                        style="height: 13vw; width: 13vw; margin: 0px; object-fit: cover;"
                      />
                      <div class="md-layout-item" style="margin-start: 10px; margin-top: 4px; padding: 0px;">
                        <p style="margin: 0px; font-size:14px; max-lines: 1; color: #7B5016;">{{comment.commenter.name}}</p>
                        <pre style="margin: 0px; font-size:14px;">{{comment.content}}</pre>
                      </div>
                    </div>

                    <div v-for="(reply, cindex) in comment.replies" :key="cindex" style="margin-top: 6px; margin-bottom: 6px; margin-start: 10vw; margin-end: 0px;">
                      <div class="md-layout-item" style="display: flex; padding: 0px;">
                        <img
                          :src=reply.commenter.imageUrl
                          :alt=reply.commenter.name
                          class="img-raised rounded-circle img-fluid"
                          style="height: 13vw; width: 13vw; margin: 0px; object-fit: cover;"
                        />
                        <div class="md-layout-item" style="margin-start: 10px; margin-top: 4px; padding: 0px;">
                          <p style="margin: 0px; font-size:14px; max-lines: 1; color: #7B5016;">{{reply.commenter.name}}</p>
                          <pre style="margin: 0px; font-size:14px;">{{reply.content}}</pre>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <br/>

                <div style="margin-bottom: 6px;">
                  <md-button class="md-primary md-round" style="width: 100%;"
                  :disabled="!canJoinActivity"
                  @click="join()">加壹</md-button>
                  <p v-if="!canJoinActivity && joinBlockedMessage"
                    style="margin: 8px 0 0; font-size: 14px; color: #7B5016; text-align: center;">
                    {{ joinBlockedMessage }}
                  </p>
                </div>

                <div class="md-layout" style="display: flex; align-items: center;">
                  <div class="md-layout-item" style="padding-end: 7.5px;">
                    <md-button class="md-rose md-round" style="width: 100%;"
                    @click="shareActivity()">分享</md-button>
                  </div>
                  <div class="md-layout-item" style="padding-start: 7.5px;">
                    <md-button class="md-info md-round" style="width: 100%;"
                    @click="$router.push({ name: 'installation' })">取得APP使用完整功能</md-button>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    

  </div>
</template>

<script>
import Vue from "vue"
const axios = require('axios').default

// Dev-only App JWT for ?simulation=true (no LIFF bootstrap).
const SIMULATION_APP_ACCESS_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.8NCFS2tEYbHKKsKj4_HoT90rVlbTeSu0OZt47ikU8MEraOr-0Wikao6G1woR0nChTOat9OGIK6QioL69Y8l2VwGaWRztqoAtnQZQZPp9E5YN_0OWvIR7dcG23CMNMujrU6ErXG_GXMHqyJT-1FLYucGNipMFbACgg3GRU0dJ1ds.hyp1f_Lv4qkOQSK96kv9bgVlWFF6OlFz0K2bSMxN55Q'

export default {
  bodyClass: "liff-activity-page",
  data() {
    return {
      responsive: false,
      activity: null,
      activityImageUrl: null,
      activityStartTime: null,
      activityEndTime: null,
      activityId: null,
      appAccessToken: null,
      appUserId: null,
      profile: null,
      comments: [],

      message: null,

      simulation: false,
      directShare: false
    };
  },
  props: {
    img: {
      type: String,
      default: require("@/assets/img/app_icon.png")
    }
  },
  methods: {
    resolveActivityId() {
      const fromRoute = this.$route && this.$route.query && this.$route.query.activityId
      if (fromRoute) {
        return fromRoute
      }
      const params = new URLSearchParams(window.location.search)
      const direct = params.get('activityId')
      if (direct) {
        return direct
      }
      const liffState = params.get('liff.state')
      if (liffState) {
        const stateQuery = liffState.charAt(0) === '?' ? liffState.slice(1) : liffState
        return new URLSearchParams(stateQuery).get('activityId')
      }
      return null
    },
    formatLiffError(error) {
      if (!error) {
        return 'Failed to initialize LIFF'
      }
      if (error.message === 'activity not browsable') {
        return '無法瀏覽活動'
      }
      if (error.message === 'activity not shareable') {
        return '無法分享此活動'
      }
      if (error.message === 'missing activityId') {
        return '缺少活動資訊'
      }
      if (error.message === 'LINE access token missing') {
        return '請在 LINE 中開啟此頁面'
      }
      if (!error.response) {
        return '無法連線至伺服器，請稍後再試'
      }
      const code = error.response.data && error.response.data.status
      if (code === 'F_TOKEN_INVALID' || code === 'F_TOKEN_EXPIRED') {
        return '登入驗證失敗，請關閉後重新開啟'
      }
      return 'Failed to initialize LIFF'
    },
    apiV1Url(path) {
      return Vue.Constants.BADMINTON_API_V1_URL + path
    },
    appAuthHeaders() {
      const headers = {}
      headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + this.appAccessToken
      return headers
    },
    bootstrapAppSession(lineAccessToken, profile) {
      const body = {
        lineUserId: profile.userId,
        displayName: profile.displayName,
      }
      if (profile.statusMessage) {
        body.statusMessage = profile.statusMessage
      }
      if (profile.pictureUrl) {
        body.pictureUrl = profile.pictureUrl
      }

      const headers = {}
      headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + lineAccessToken

      return axios.post(this.apiV1Url('auth/line'), body, { headers }).then((response) => {
        this.appAccessToken = response.data.data.accessToken
        if (response.data.data.user && response.data.data.user.id) {
          this.appUserId = response.data.data.user.id
        }
      })
    },
    refreshAppSessionIfPossible() {
      if (this.simulation) {
        this.appAccessToken = SIMULATION_APP_ACCESS_TOKEN
        return Promise.resolve()
      }
      if (!liff.isInClient() || !liff.isLoggedIn()) {
        return Promise.reject(new Error('not logged in'))
      }
      const lineAccessToken = liff.getAccessToken()
      const profilePromise = this.profile
        ? Promise.resolve(this.profile)
        : liff.getProfile().then((profile) => {
          this.profile = profile
          return profile
        })
      return profilePromise.then((profile) => this.bootstrapAppSession(lineAccessToken, profile))
    },
    apiV1Request(requestFn, retried) {
      return requestFn().catch((error) => {
        const status = error.response && error.response.status
        const code = error.response && error.response.data && error.response.data.status
        if (!retried && status === 401 && code === 'F_TOKEN_EXPIRED') {
          return this.refreshAppSessionIfPossible().then(() => requestFn())
        }
        throw error
      })
    },
    applyActivity(activity) {
      activity.participants = activity.participants || []
      this.activity = activity
      if (activity.image) {
        this.activityImageUrl = Vue.Constants.BADMINTON_API_URL_IMAGES + activity.image.filePath
      } else {
        this.activityImageUrl = null
      }

      const timeS = new Date()
      timeS.setTime(Date.parse(activity.startTime))
      this.activityStartTime = timeS

      const timeE = new Date()
      timeE.setTime(Date.parse(activity.endTime))
      this.activityEndTime = timeE
    },
    isActivityBrowsable(activity) {
      return activity.status === Vue.Constants.ACTIVITY_STATUS_OPEN
        || activity.status === Vue.Constants.ACTIVITY_STATUS_SURE2GO
    },
    isActivityShareable(activity) {
      return activity.status === Vue.Constants.ACTIVITY_STATUS_OPEN
        || activity.status === Vue.Constants.ACTIVITY_STATUS_SURE2GO
        || activity.status === Vue.Constants.ACTIVITY_STATUS_KICKOFF
    },
    loadActivity(options) {
      const forShare = options && options.forShare
      return this.apiV1Request(() => {
        return axios.get(this.apiV1Url('activities/' + this.activityId), {
          headers: this.appAuthHeaders(),
        })
      }).then((response) => {
        const activity = response.data.data.activity
        if (forShare) {
          if (!this.isActivityShareable(activity)) {
            throw new Error('activity not shareable')
          }
        } else if (!this.isActivityBrowsable(activity)) {
          throw new Error('activity not browsable')
        }
        this.applyActivity(activity)
      })
    },
    loadComments() {
      return this.apiV1Request(() => {
        return axios.get(this.apiV1Url('activities/' + this.activityId + '/comments'), {
          headers: this.appAuthHeaders(),
        })
      }).then((response) => {
        const comments = response.data.data.comments || []
        comments.forEach((comment) => {
          comment.replies = comment.replies || []
        })
        this.comments = comments
      })
    },
    actuallyPeopleCountOf(participant) {
      return participant.numOfPeople - participant.numOfCancel - participant.numOfWithdraw
    },
    particiantNoteOf(index, participant) {
      const i = this.particiantIndexNumberOf(index)
      if (this.activity.maxParticipant != 0 && (i <= this.activity.maxParticipant) && (i - 1 + this.actuallyPeopleCountOf(participant) > this.activity.maxParticipant) ) {
        return '+' + this.actuallyPeopleCountOf(participant) + ' (錄取' + (this.activity.maxParticipant - i + 1) + '位)'
      } else {
        return '+' + this.actuallyPeopleCountOf(participant)
      }
    },
    particiantIndexStyle(index, participant) {
      if (this.activity.maxParticipant != 0) {
        if (this.particiantIndexNumberOf(index) > this.activity.maxParticipant) {
          return {
            color: "#FF667033"
          }
        } else if (this.particiantIndexNumberOf(index) - 1 + this.actuallyPeopleCountOf(participant) > this.activity.maxParticipant) {
          return {
            color: "#7B501627"
          }
        } else {
          return {
            color: "#3150930D"
          }
        }
      } else {
        return {
          color: "#3150930D"
        }
      }
    },
    particiantIndexNumberOf(index) {
      var i = 0
      var t = 1
      if (this.activity.participants) {
        for (var p of this.activity.participants) {
          if (index == i) {
            return t
          }

          t = t + this.actuallyPeopleCountOf(p)
          i = i + 1
        }
      }

      return t
    },
    voucherNameOf(participant) {
      if (participant.vouchers && participant.vouchers.length != 0) {
        const voucher = participant.vouchers[0]
        if (voucher.name) {
          return voucher.name
        }
      }

      return ''
    },
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    getFormattedDateString(date) {
      return date.toLocaleString([], { hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", weekday: "short" })
    },
    leave(participant) {
      if (!liff.isInClient() || !liff.isLoggedIn()) {
        this.showNotificationError('Environment Issue')
        return
      }

      this.activityId = this.$route.query.activityId
      const loader = this.startLoading()
      const body = { numOfCancel: participant.numOfPeople - participant.numOfPaid }

      this.apiV1Request(() => {
        return axios.patch(
          this.apiV1Url('activities/' + this.activityId + '/participants/' + participant.id),
          body,
          { headers: this.appAuthHeaders() },
        )
      }).then((response) => {
        this.applyActivity(response.data.data.activity)
        loader.hide()
        this.showNotificationSuccess('您已成功減壹。')
      }).catch(() => {
        loader.hide()
        this.showNotificationError('減壹失敗…')
      })
    },
    join() {
      if (!this.canJoinActivity) {
        return
      }
      if (!liff.isInClient() || !liff.isLoggedIn()) {
        this.showNotificationError('Environment Issue')
        return
      }

      this.activityId = this.$route.query.activityId
      const loader = this.startLoading()

      this.apiV1Request(() => {
        return axios.post(
          this.apiV1Url('activities/' + this.activityId + '/join'),
          {},
          { headers: this.appAuthHeaders() },
        )
      }).then((response) => {
        this.applyActivity(response.data.data.activity)
        loader.hide()
        this.showNotificationSuccess('您已成功加壹。')
      }).catch((error) => {
        loader.hide()
        const code = error.response && error.response.data && error.response.data.status
        if (code === 'F_ATTENDANCE_RESTRICTION_BLOCKED') {
          this.showNotificationError(this.joinBlockedMessage || '目前無法報名此活動。')
        } else {
          this.showNotificationError('加壹失敗…')
        }
      })
    },
    shareActivity() {
      if (liff.isApiAvailable('shareTargetPicker')) {
        liff.shareTargetPicker([this.createMessage()]).then(function (res) {
            liff.closeWindow();
        }).catch(function (res) {
            window.alert('something wrong!');
        });
      }
    },
    createMessage() {

      var imageUrl = "https://unknown.image.url"
      if (this.activityImageUrl) {
        imageUrl = this.activityImageUrl
      }
      
      const image = {
        "type": "image",
        "url": imageUrl,
        "size": "full",
        "aspectMode": "cover",
        "aspectRatio": "16:9",
        "gravity": "center"
      }

      var contentsInner = []

      if (this.activity.group) {
        contentsInner.push({
          "type": "text",
          "text": this.activity.group.name,
          "size": "xs",
          "color": "#ffffff",
          "weight": "bold",
          "maxLines": 1
        });
      }

      contentsInner.push({
        "type": "text",
        "text": this.activity.name,
        "size": "xl",
        "color": "#ffffff",
        "weight": "bold",
        "maxLines": 1
      });

      var contents = [
        {
          "type": "box",
          "layout": "vertical",
          "contents": contentsInner
        },
        {
          "type": "text",
          "text": this.getFormattedDateString(this.activityStartTime),
          "size": "lg",
          "color": "#ffffff",
          "maxLines": 1,
          "wrap": true
        }
      ]

      if (this.activity.location) {
        contents.push({
          "type": "box",
          "layout": "horizontal",
          "contents": [
            {
              "type": "box",
              "layout": "baseline",
              "contents": [
                {
                  "type": "text",
                  "text": this.activity.location,
                  "color": "#ffffff",
                  "size": "sm",
                  "flex": 0,
                  "align": "end",
                  "maxLines": 1
                }
              ],
              "flex": 0
            }
          ]
        });
      }

      if (this.activity.fee) {
        contents.push({
          "type": "box",
          "layout": "horizontal",
          "contents": [
            {
              "type": "box",
              "layout": "baseline",
              "contents": [
                {
                  "type": "text",
                  "text": "$" + this.activity.fee,
                  "color": "#ffffff",
                  "size": "sm",
                  "flex": 0,
                  "align": "end",
                  "maxLines": 1
                }
              ],
              "flex": 0
            }
          ]
        });
      }

      const message = {
        type: 'flex',
        altText: this.activity.name,
        contents: {
          "type": "bubble",
          "body": {
            "type": "box",
            "layout": "vertical",
            "contents": [
              image,
              {
                "type": "box",
                "layout": "vertical",
                "contents": [],
                "position": "absolute",
                "width": "100%",
                "height": "100%",
                "background": {
                  "type": "linearGradient",
                  "angle": "0deg",
                  "startColor": "#00000099",
                  "endColor": "#00000000"
                }
              },
              {
                "type": "box",
                "layout": "horizontal",
                "contents": [
                  {
                    "type": "box",
                    "layout": "vertical",
                    "contents": contents,
                    "spacing": "xs"
                  }
                ],
                "position": "absolute",
                "offsetBottom": "0px",
                "offsetStart": "0px",
                "offsetEnd": "0px",
                "paddingAll": "20px"
              }
            ],
            "paddingAll": "0px",
            "backgroundColor": "#0271C9",
            "action": {
              "type": "uri",
              "uri": "https://liff.line.me/" + process.env.VUE_APP_LIFF_ACTIVITY_ID + "?activityId=" + this.activity.id
            }
          }
        }
      }

      return message
    },
    startLoading() {
      const loader = this.$loading.show({
        container: null,
        canCancel: false,
        onCancel: this.onCancelLoading,
        color: '#3f51b5',
        backgroundColor: '#757575'
      })
      return loader
    },
    onCancelLoading() {
    },
    initLiffPage() {
      const loader = this.startLoading()
      this.activityId = this.resolveActivityId()
      if (!this.activityId) {
        loader.hide()
        this.showNotificationError('缺少活動資訊')
        return
      }

      if (this.simulation) {
        this.appAccessToken = SIMULATION_APP_ACCESS_TOKEN
        this.loadActivity({ forShare: this.directShare }).then(() => {
          loader.hide()
        }).catch((error) => {
          loader.hide()
          this.showNotificationError(this.formatLiffError(error))
        })
        return
      }

      liff.getProfile().then((profile) => {
        this.profile = profile
        const lineAccessToken = liff.getAccessToken()
        if (!lineAccessToken) {
          return Promise.reject(new Error('LINE access token missing'))
        }
        return this.bootstrapAppSession(lineAccessToken, profile)
      }).then(() => {
        return this.loadActivity({ forShare: this.directShare })
      }).then(() => {
        loader.hide()
        if (this.directShare) {
          this.shareActivity()
        } else {
          this.loadComments().catch(() => {})
        }
      }).catch((error) => {
        loader.hide()
        this.showNotificationError(this.formatLiffError(error))
      })
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    this.simulation = (this.$route.query.simulation === 'true')
    this.directShare = (this.$route.query.share === 'true')

    const liffId = process.env.VUE_APP_LIFF_ACTIVITY_ID
    if (!liffId) {
      this.showNotificationError('LIFF 設定未完成')
      return
    }

    liff.init({ liffId: liffId }).then(() => {
        if (this.simulation || (liff.isInClient() && liff.isLoggedIn())) {
          this.initLiffPage()
        } else if (liff.isInClient() && !liff.isLoggedIn()) {
          liff.login().then(() => {
            this.initLiffPage()
          }).catch(() => {
            this.showNotificationError('請登入 LINE 後再試')
          })
        } else {
          this.showNotificationError('Environment Issue. 目前只支援手機版喔！')
        }
    }).catch(() => {
        this.showNotificationError('Failed to initialize LIFF')
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  computed: {
    headerStyle() {
      if (this.activity) {
        if (this.activityImageUrl) {
          return {
            backgroundImage: `url(${this.activityImageUrl})`
          };
        } else {
          return {
            backgroundColor: "#0271C9"
          };
        }
      } else {
        return {
          backgroundColor: "#0271C9"
        };
      }
    },
    canJoinActivity() {
      if (!this.activity || !this.activity.joinEligibility) {
        return true
      }
      return this.activity.joinEligibility.canJoin !== false
    },
    joinBlockedMessage() {
      const eligibility = this.activity && this.activity.joinEligibility
      if (!eligibility || eligibility.canJoin !== false) {
        return ''
      }
      const reasons = eligibility.blockedReasons || []
      const parts = []
      if (reasons.indexOf('absence') >= 0) {
        parts.push('缺席次數')
      }
      if (reasons.indexOf('withdraw') >= 0) {
        parts.push('退報名次數')
      }
      if (parts.length === 0) {
        return '目前無法報名此活動。'
      }
      return '因近期' + parts.join('及') + '達上限，暫無法報名此活動。'
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.margin_top_20 {
  margin-top: 20px;
}

.margin_bottom_10 {
  margin-bottom: 10px;
}

pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}

</style>
